import { GroupSchema, MemberSchema } from 'types/Changemkr';
import composeDisplayName from 'utils/composeDisplayName';

export default function extractGroupOrMemberName(schema: MemberSchema | GroupSchema) {
  return 'name' in schema ? schema.name : composeDisplayName(schema.user);
}
